var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 243 252",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3446 -1145)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3654.92 1395 3471.21 1395C3458.45 1394.98 3448.09 1384.64 3448 1371.83L3448 1193.31C3448.02 1180.44 3458.4 1170.02 3471.21 1170L3535.54 1170C3538.38 1170.47 3540.3 1173.16 3539.84 1176.01 3539.47 1178.23 3537.74 1179.97 3535.54 1180.33L3471.21 1180.33C3464.16 1180.35 3458.46 1186.09 3458.46 1193.17L3458.46 1371.83C3458.46 1378.91 3464.16 1384.65 3471.21 1384.67L3654.92 1384.67C3661.99 1384.67 3667.71 1378.92 3667.71 1371.83L3667.71 1306.41C3668.18 1303.56 3670.86 1301.63 3673.7 1302.09 3675.91 1302.46 3677.64 1304.19 3678 1306.41L3678 1371.83C3677.91 1384.59 3667.63 1394.91 3654.92 1395Z",
    fill: "#E90029",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3509.23 1329C3506.34 1329 3504 1326.66 3504 1323.77 3504 1322.38 3504.56 1321.04 3505.55 1320.06L3667.1 1159.38 3564.45 1159.38C3561.6 1159.85 3558.91 1157.92 3558.44 1155.07 3557.97 1152.22 3559.91 1149.54 3562.76 1149.07 3563.32 1148.98 3563.89 1148.98 3564.45 1149.07L3674.81 1149.07C3676.29 1149.07 3677.63 1149.07 3678.87 1149.07L3679.73 1149.07C3683.18 1149.41 3685 1150.51 3685 1154.19 3684.99 1155.66 3684.36 1157.05 3683.28 1158.04L3513.02 1327.45C3512.03 1328.47 3510.66 1329.03 3509.23 1329Z",
    fill: "#E90029",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3680.97 1272C3678.22 1272 3676 1269.71 3676 1266.89L3676 1154.15C3676 1151.31 3678.24 1149 3681 1149 3683.76 1149 3686 1151.31 3686 1154.15L3686 1266.82C3686.02 1269.66 3683.79 1271.98 3681.03 1272 3681.01 1272 3680.99 1272 3680.97 1272Z",
    fill: "#E90029",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.05b8469a46cb242cd5f975dae70bc85f.svg";
export { ForwardRef as ReactComponent };